import { getBasePath } from '../utilities/base-path.js';

export async function discover(root: Element | ShadowRoot) {
  const tags = new Set<string>();
  const lookAheadMargin = 0; // Example static value, adjust as needed
  const options = {
    rootMargin: `${lookAheadMargin * 1}px`,
    threshold: 0,
  };
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        const tag = el.tagName.toLowerCase();
        if (tag.startsWith('outline-') && !customElements.get(tag)) {
          tags.add(tag);
        }
      }
    });

    if (tags.size > 0) {
      const tagsToRegister = [...tags];
      Promise.allSettled(tagsToRegister.map(tagName => register(tagName)));
    }
  }, options);

  root.querySelectorAll('*').forEach(node => observer.observe(node));
}

function register(tagName: string): Promise<void> {
  const path = getBasePath(`components/${tagName}/${tagName}.js`);

  if (customElements.get(tagName)) {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    import(path)
      .then(() => {
        return resolve();
      })
      .catch(error => {
        console.error(
          `Error occurred during import of <${tagName}> from ${path}:`,
          error
        );
        reject(new Error(`Unable to autoload <${tagName}> from ${path}`));
      });
  });
}

// Initial discovery
discover(document.body);
